import GameTable from "./GameTable";
export default GameTable